import React from 'react';
import SubcourseOverallCard from '../../../../components/Learner/LanguageLearning/SubcourseOverallCard';
import QuickPracticeButton from '../../../../components/Learner/LanguageLearning/QuickPracticeButton';
import WritingPracticeButton from '../../../../components/Learner/LanguageLearning/WritingPracticeButton';
import SpeakingPracticeButton from '../../../../components/Learner/LanguageLearning/SpeakingPracticeButton';
import DrillVocabButton from '../../../../components/Learner/LanguageLearning/DrillVocabButton';
import NotesView from '../../../../components/Learner/LanguageLearning/NotesView';
import MobileLessonsTree from '../../../../components/Learner/LanguageLearning/MobileLessonsTree';

export default function LevelPanelMobileView({
  level,
  levelNumber,
  progress,
  courseTreeLoading,
  isMastered,
  practices,
  vocabReady,
  vocabStats,
  notes,
  notesLoading,
  notesOverlayOpen,
  selectedSkillId,
  activeLessonId,
  skills,
  skillsCache,
  displayLessons,
  mobileExpandedLessonIds,
  treeLoadingLessonId,
  notesInlineContentRef,
  courseTree,
  onQuickPracticeStart,
  onWritingPracticeStart,
  onSpeakingPracticeStart,
  onDrillVocabStart,
  onToggleLesson,
  onSkillClick,
  onCloseNotesOverlay,
  findSubcourseByLevel,
  updateUrlParams,
  userClickedSkillRef,
  treeClickedSkillIdRef,
  setSelectedSkillId,
}) {
  return (
    <div className="level-panel w-full flex flex-col min-h-[100dvh] overflow-visible relative">
      <div className="mobile-practice-view mobile-single-view flex-1 w-full p-0 overflow-visible pt-6">
        <div className="practice-section flex-1 min-w-0 flex flex-col gap-2 touch-action-pan-y max-md:my-2 max-md:mx-4 max-md:py-3 max-md:px-3 max-md:bg-[#f1f5f9] dark:max-md:bg-[#1e293b] max-md:rounded-[20px] max-md:border max-md:border-[#e2e8f0] dark:max-md:border-white/10">
          <SubcourseOverallCard
            level={level}
            levelNumber={levelNumber}
            progress={progress}
            loading={courseTreeLoading}
            isMastered={isMastered}
            compact
          />
          <div className="practice-cards-container flex flex-col gap-3 max-md:flex-col max-md:gap-3 max-md:p-0 max-md:w-full max-md:min-w-0">
            <QuickPracticeButton
              level={practices.quick.level}
              completed={practices.quick.progress}
              total={100}
              onStart={onQuickPracticeStart}
            />
            <WritingPracticeButton
              level={practices.writing.level}
              completed={practices.writing.progress}
              total={100}
              onStart={onWritingPracticeStart}
            />
            <SpeakingPracticeButton
              level={practices.speaking.level}
              completed={practices.speaking.progress}
              total={100}
              onStart={onSpeakingPracticeStart}
            />
          </div>
        </div>
        {vocabReady && (
          <DrillVocabButton
            level={courseTreeLoading ? null : vocabStats.level ?? 0}
            completed={courseTreeLoading ? null : vocabStats.progress ?? 0}
            total={100}
            onStart={onDrillVocabStart}
            loading={courseTreeLoading}
          />
        )}
        {notesOverlayOpen ? (
          <div ref={notesInlineContentRef} className="mobile-notes-inline-content w-full p-0 overflow-visible">
            <NotesView
              title="Reading materials"
              notes={notes}
              loading={notesLoading}
              skillId={selectedSkillId}
              lessonId={activeLessonId}
              skills={activeLessonId ? (skillsCache[activeLessonId]?.skills ?? skills) : skills}
              currentSkillId={selectedSkillId}
              onSkillChange={(skillId) => {
                userClickedSkillRef.current = true;
                treeClickedSkillIdRef.current = skillId;
                setSelectedSkillId(skillId);
                if (courseTree && activeLessonId && findSubcourseByLevel) {
                  const subcourse = findSubcourseByLevel(courseTree, level);
                  const subcourseId = subcourse?.id || subcourse?._id;
                  if (subcourseId) {
                    updateUrlParams({
                      'subcourse-id': subcourseId,
                      'lesson-id': activeLessonId,
                      'skill-id': skillId,
                    });
                  }
                }
                setTimeout(() => {
                  userClickedSkillRef.current = false;
                  treeClickedSkillIdRef.current = null;
                }, 300);
              }}
              onBack={onCloseNotesOverlay}
              isMobile={true}
              onReadingMaterialClick={onCloseNotesOverlay}
            />
          </div>
        ) : (
          <MobileLessonsTree
            lessons={displayLessons}
            skillsCache={skillsCache}
            expandedLessonIds={mobileExpandedLessonIds}
            loadingLessonId={treeLoadingLessonId}
            practices={practices}
            loadingStats={courseTreeLoading}
            onToggleLesson={onToggleLesson}
            onSkillClick={onSkillClick}
            onQuickPracticeStart={onQuickPracticeStart}
            onWritingPracticeStart={onWritingPracticeStart}
            onSpeakingPracticeStart={onSpeakingPracticeStart}
          />
        )}
      </div>
    </div>
  );
}
